import { ReactNode } from 'react';
import { Stack, TextStyle, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { Dash } from '@mews-commander/ui';

interface Props {
    description: Mews.TextKey | Mews.TextKeyUnion;
    tooltippedIcon?: ReactNode;
    value: ReactNode;
    textStyle?: `${TextStyle}`;
}

export const PaymentPlanDetailItem = ({ description, value, tooltippedIcon, textStyle = 'bodyLarge' }: Props) => (
    <>
        <Typography textStyle={textStyle} variant="tertiary" as="div">
            <Stack spacing="50" itemAlignment="center">
                {lt(description)}
                {tooltippedIcon}
            </Stack>
        </Typography>
        <Typography textStyle={textStyle} as="div">
            {value ?? <Dash />}
        </Typography>
    </>
);
